import React from 'react';
import dynamic from 'next/dynamic';
import css from 'styled-jsx/css';

import Header from './common/Header';
import Banner from './home/Banner';
import Community from './home/Community';
import Carousel from './home/Carousel';
import Footer from './common/Footer';
//import Survey from './home/Survey';
const Contact = dynamic(() => import('./common/Contact'), {
  ssr: false
});
const Survey = dynamic(() => import('./home/Survey'), {
  ssr: false
});
const Home = ({ profile, landing }) => (
  <div className="home__scroll">
    <Header profile={profile} />
    <Banner banner={landing.banner} />
    <Community />
    <Carousel testimonies={landing.testimonies} />
    <Survey
      profiles={landing.survey.profiles}
      questions={landing.survey.questions}
    />
    <Contact />
    <Footer />
    <style jsx>{styles}</style>
  </div>
);

const styles = css`
  .home__scroll {
    scroll-behavior: smooth;
    height: 100vh;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }
`;

export default Home;
